/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Checkbox, Form, message } from "antd";
import { Title } from "./Common";
import MapPropsContext from "../MapPropsContext";
import Radio from "antd/es/radio";
import { StyledButton } from "../../../styled-components/Button";
import StyledCheckBoxWithLabel from "../../../styled-components/StyledCheckboxWithLabel";
import {
  TI_ALL_CARRIER_BUTTON,
  TI_ALL_SERVICE_RECEPTION_BUTTON,
  TI_EXTEND_BOUNDARY_CHECK_BOX,
  TI_HIDE_CARRIER_CHECK_BOX,
} from "../../../Constants";

const OPTIONS_CUSTOMER = [
  { value: "", label: "전체" },
  { value: 542604, label: "SKT" },
  { value: 542610, label: "KT" },
  { value: 39818, label: "LGU+" },
];

const OPTIONS_SERVICE = [
  { value: "", label: "전체" },
  //  {value: '05,06', label: '2G'},
  { value: "15", label: "3G" },
  { value: "18,19", label: "4G" },
  { value: "43,45", label: "5G" },
];

message.config({
  top: 250,
  duration: 10,
  maxCount: 1,
});

const info = () => {
  message.info({
    content: (
      <span style={{ fontSize: 15 }}>
        {" "}
        공원 경계 확장검색시 로딩 속도에 지연이 발생되오니 양해 부탁드립니다.
      </span>
    ),
  });
};
/*

 */

function WidgetNationalParkFilter({ disabled, isBukhansan, currentPark }) {
  const {
    widgetState,
    onChangeWidgetState,
    isHideFilteredPointsLayer,
    setIsHideFilteredPointsLayer,
  } = useContext(MapPropsContext);

  const { agency_name, service_code, extra_search } = widgetState;
  const [activeExtraInfo, setActiveExtraInfo] = useState(extra_search);

  const extraOncChange = useCallback(({ target: { checked } }) => {
    setActiveExtraInfo(checked);
    onChangeWidgetState({ target: { name: "extra_search", value: checked } });
    if (checked) {
      info();
    }
  }, []);

  useEffect(() => {
    setActiveExtraInfo(false);
  }, [currentPark]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title>사업자</Title>
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "4px" }}>
            <StyledCheckBoxWithLabel
              tabIndex={TI_HIDE_CARRIER_CHECK_BOX}
              checked={isHideFilteredPointsLayer}
              onChange={({ target: { checked } }) =>
                setIsHideFilteredPointsLayer(checked)
              }
              label="숨기기"
            />
          </div>
          <StyledCheckBoxWithLabel
            tabIndex={TI_EXTEND_BOUNDARY_CHECK_BOX}
            checked={activeExtraInfo}
            disabled={isBukhansan}
            onChange={extraOncChange}
            label="경계확장검색(3km)"
          />
        </div>
      </div>

      <div style={{ display: "flex", marginBottom: "1em" }}>
        {OPTIONS_CUSTOMER.map((customer, index) => (
          <StyledButton
            tabIndex={TI_ALL_CARRIER_BUTTON + index}
            style={{ flex: 1, borderRadius: "0px 0px 0px 0px" }}
            isActive={agency_name === customer.value}
            onClick={() =>
              onChangeWidgetState({
                target: {
                  checked: true,
                  className: "",
                  defaultChecked: false,
                  disabled: undefined,
                  name: "agency_name",
                  prefixCls: "ant-radio-button",
                  style: {},
                  type: "radio",
                  value: customer.value,
                },
              })
            }
          >
            {customer.label}
          </StyledButton>
        ))}

        {/* <StyledButton
          isActive={agency_name === 542604}
          style={{ flex: 1, borderRadius: "0px 0px 0px 0px" }}
          onClick={() =>
            onChangeWidgetState({
              target: {
                checked: true,
                className: "",
                defaultChecked: false,
                disabled: undefined,
                name: "agency_name",
                prefixCls: "ant-radio-button",
                style: {},
                type: "radio",
                value: 542604,
              },
            })
          }
        >
          SKT
        </StyledButton>
        <StyledButton
          isActive={agency_name === 542610}
          style={{ flex: 1, borderRadius: "0px 0px 0px 0px" }}
          onClick={() =>
            onChangeWidgetState({
              target: {
                checked: true,
                className: "",
                defaultChecked: false,
                disabled: undefined,
                name: "agency_name",
                prefixCls: "ant-radio-button",
                style: {},
                type: "radio",
                value: 542610,
              },
            })
          }
        >
          KT
        </StyledButton>
        <StyledButton
          isActive={agency_name === 39818}
          style={{ flex: 1, borderRadius: "0px 4px 4px 0px" }}
          onClick={() =>
            onChangeWidgetState({
              target: {
                checked: true,
                className: "",
                defaultChecked: false,
                disabled: undefined,
                name: "agency_name",
                prefixCls: "ant-radio-button",
                style: {},
                type: "radio",
                value: 39818,
              },
            })
          }
        >
          LGU+
        </StyledButton> */}
      </div>

      <Title>서비스</Title>
      <div style={{ display: "flex" }}>
        {OPTIONS_SERVICE.map((service, index) => (
          <StyledButton
            tabIndex={TI_ALL_SERVICE_RECEPTION_BUTTON + index}
            style={{ flex: 1, borderRadius: "0px 0px 0px 0px" }}
            isActive={service_code === service.value}
            onClick={() =>
              onChangeWidgetState({
                target: {
                  checked: true,
                  className: "",
                  defaultChecked: false,
                  disabled: undefined,
                  name: "service_code",
                  prefixCls: "ant-radio-button",
                  style: {},
                  type: "radio",
                  value: service.value,
                },
              })
            }
          >
            {service.label}
          </StyledButton>
        ))}
      </div>
      {/* <Radio.Group
        name="service_code"
        value={service_code}
        buttonStyle={"solid"}
        size={"small"}
        onChange={onChangeWidgetState}
        style={{ width: "100%" }}
      >
        <div style={{ display: "flex", width: "100%" }}>
          {OPTIONS_SERVICE.map(({ value, label }) => (
            <Radio.Button
              value={value}
              key={value}
              style={BUTTON_STYLE}
              disabled={disabled || isHideFilteredPointsLayer}
            >
              {label}
            </Radio.Button>
          ))}
        </div>
      </Radio.Group> */}
    </div>
  );
}

export default WidgetNationalParkFilter;
